import React from "react";
import { Card, Table, Tabs, Tag, Typography } from "antd";
import { 
  LaptopOutlined, 
  AppstoreOutlined, 
  InfoCircleOutlined 
} from "@ant-design/icons";
import DashboardLayout from "../LayoutNavbar/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../LayoutNavbar/Navbars/DashboardNavbar";
import EmployeeAssetsService from "Services/EmployeeServices/EmployeeAssetsService";

const { Text } = Typography;

function EmployeeAssets() {
  const { 
    softwarecol, 
    hardwarecol, 
    dataSource, 
    datahardwareSource 
  } = EmployeeAssetsService();

  // Define the content for each tab to keep the return statement clean
  const tabItems = [
    {
      key: "1",
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <LaptopOutlined />
          Hardware Assets
        </span>
      ),
      children: (
        <div className="table-responsive">
          <Table
            className="custom-table"
            columns={hardwarecol}
            dataSource={datahardwareSource}
            pagination={{ 
              pageSize: 10,
              showSizeChanger: false,
              hideOnSinglePage: true 
            }}
            bordered={false} // Removes heavy outer boxing
            size="middle"
            rowKey={(record) => record.id || record.assetId}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <AppstoreOutlined />
          Software Assets
        </span>
      ),
      children: (
        <div className="table-responsive">
          <Table
            className="custom-table"
            columns={softwarecol}
            dataSource={dataSource}
            pagination={{ 
              pageSize: 10,
              showSizeChanger: false,
              hideOnSinglePage: true 
            }}
            bordered={false}
            size="middle"
            rowKey={(record) => record.id || record.softwareId}
          />
        </div>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-4 mt-4">
          <Card 
            className="card-professional" 
            title={
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <InfoCircleOutlined style={{ color: "#599c16" }} />
                <span style={{ color: "#0c313f", fontWeight: 700 }}>My Assigned Assets</span>
              </div>
            }
          >
            <Text type="secondary" style={{ display: "block", marginBottom: "20px" }}>
              View and manage the hardware and software resources currently allocated to your profile.
            </Text>
            
            <Tabs 
              defaultActiveKey="1" 
              items={tabItems} 
              className="custom-tabs"
              animated={{ inkBar: true, tabPane: true }}
            />
          </Card>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default EmployeeAssets;